import { ReactElement } from 'react'
import { Close } from '@mui/icons-material'
import { Box, Button, Divider, IconButton, Paper, Stack, Typography } from '@mui/material'
import type { SceneFinding } from 'src/state/stores/aiChatFindings'
import { SEVERITY_COLORS, SEVERITY_LABELS, findingsTitle } from './utils'

interface Props {
  findings: SceneFinding[]
  onClose: () => void
  onDismiss: (finding: SceneFinding) => void
}

/** The findings of one "!", under it; each can be dismissed. */
const FindingPopup = ({ findings, onClose, onDismiss }: Props): ReactElement => {
  return (
    <Paper
      elevation={6}
      sx={{
        position: 'absolute',
        top: 48,
        width: 340,
        maxHeight: 420,
        overflowY: 'auto',
        p: 1.5,
      }}
      data-cy="scene-finding-popup"
    >
      <Stack direction="row" alignItems="center" spacing={1} mb={1}>
        <Typography variant="subtitle2" flexGrow={1} noWrap>
          {findingsTitle(findings.length)}
        </Typography>
        <IconButton size="small" aria-label="Schließen" onClick={onClose}>
          <Close fontSize="small" />
        </IconButton>
      </Stack>
      <Stack spacing={1} divider={<Divider flexItem />}>
        {findings.map((finding, index) => (
          <Box
            key={`${index}-${finding.rule}`}
            sx={{ borderLeft: 3, borderColor: SEVERITY_COLORS[finding.severity], pl: 1 }}
            data-cy="scene-finding"
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="caption" color="text.secondary" flexGrow={1} noWrap>
                {`${SEVERITY_LABELS[finding.severity]} · ${finding.rule}`}
              </Typography>
              <Button
                size="small"
                onClick={() => onDismiss(finding)}
                sx={{ py: 0, minWidth: 0 }}
                data-cy="scene-finding-dismiss"
              >
                Ausblenden
              </Button>
            </Stack>
            <Typography variant="body2" fontWeight={500}>
              {finding.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {finding.detail}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Paper>
  )
}

export default FindingPopup
